import React from 'react'
import logo from '../assest/logo1.png'
import '../stylings/header.css'
import { Link } from 'react-router-dom'
import admissionForm from '../assest/admission_form.pdf'
import newGif from '../assest/newGif.gif'
import { MdOutlineStickyNote2 } from 'react-icons/md'
import { RiGraduationCapFill } from 'react-icons/ri'
import { FaAward } from 'react-icons/fa'

const Header = () => {
    return (
        <div className="headerTop">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 headerContainer">

                        <div className="headerTop_Left">
                            <Link to="/" tabIndex="0">
                                <img src={logo} /></Link>
                        </div>

                        <div className="headerTop_Right">
                            <div className="ContBox-Container">
                                <div className="ContBox">
                                    <div className="ContBoxleft">
                                        <MdOutlineStickyNote2 />
                                    </div>
                                    <div className="ContBoxRight">
                                        <Link to="/public-disclosure" target="_blank" tabIndex="0">
                                            <div className="ContBoxHd">Public Disclosure</div>
                                            <div className="ContBoxContent">
                                                Click Here
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="ContBox">
                                    <div className="ContBoxleft">
                                        <FaAward />
                                    </div>
                                    <div className="ContBoxRight">
                                    <a href="https://apnipathshala.org" target="_blank"  rel="noopener noreferrer">
                                        <div className="ContBoxHd">Apni Pathshala</div>
                                        <div className="ContBoxContent">
                                        Click Here
                                        </div>
                                    </a>
                                    </div>
                                </div>
                                <div className="ContBox">
                                    <div className="ContBoxleft">
                                        <RiGraduationCapFill />
                                    </div>
                                    <div className="ContBoxRight">
                                        <Link to={'/wtl_admissionform.pdf'} target='_blank'>
                                            <div className="ContBoxHd">Admission</div>
                                            <div className="ContBoxContent">
                                                Registration Open 2026-2027
                                            </div>
                                            <div className="img-container">
                                                <img src={newGif} alt="new gif" />
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            {/* <div className="btn_top">
                                <Link to="/login" tabIndex="0">myCampus Login</Link>
                                <Link to="/public-disclosure" tabIndex="0">Public Disclosure</Link>

                                <Link to={admissionForm} tabIndex="0" target='_blank' className='admission-form'> Download Admission Form
                                    <div className="img-container">
                                        <img src={newGif} alt="news-new-gif" />
                                    </div>
                                </Link>
                            </div> */}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header
